import {Athlete} from "./athlete";
import {Category} from "./category";
import {Season} from "./season";
import {PaymentRequest} from "./paymentRequest";

export class AthleteSeason {

    athleteId?: string;
    athlete?: Athlete;
    athletePaymentRequestId?: string;
    athletePaymentRequest?: PaymentRequest;
    categoryId?: string;
    category?: Category;
    seasonId?: string;
    season?: Season;
    status?: string;

    constructor(raw?: AthleteSeason) {

        if ( raw ) {
            this.athleteId = raw.athleteId;
            this.athletePaymentRequestId = raw.athletePaymentRequestId;
            this.categoryId = raw.categoryId;
            this.seasonId = raw.seasonId;
            this.status = raw.status;
            this.athlete = new Athlete(raw.athlete);
            this.category = new Category(raw.category);
            this.season = new Season(raw.season);
            this.athletePaymentRequest = new PaymentRequest(raw.athletePaymentRequest);
        }
    }
    
}
